// token 失效
export const TOKEN_INVALID = 'TOKEN_INVALID'
// 打开登录弹窗
export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL'
